import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'lbinch', label: 'lb per inch' },
  { key: 'lbyard', label: 'lb per yard' },
  { key: 'lbfeet', label: 'lb per feet' },
  { key: 'kgmet',  label: 'kg per metre' },
];

// Base: lb per inch
const factors = {
  lbinch: 1,
  lbyard: 36,
  lbfeet: 12,
  kgmet:  17.858,
};

export const ConvWtper = () => (
  <UnitConverter
    title="Weight / unit length"
    units={units}
    factors={factors}
    explanationTitle="Units of weight per unit length"
    explanation="1 lb / ft = 1.488 kg / m. In the English system, 1 lb per foot is approximately 1.49 times 1 kilogram per metre in the metric system."
  />
);
